import {Action} from '@ngrx/store';

export enum ELayoutActions {
	SetSidebarPresentAsOverlay = '[Layout] Set Sidebar Present As Overlay',
	SetSidebarPresentAsOverlayVisible = '[Layout] Set Sidebar Present As Overlay Visible',
}

export class SetSidebarPresentAsOverlay implements Action {
	public readonly type = ELayoutActions.SetSidebarPresentAsOverlay;

	constructor(public presentAsOverlay: boolean) {
	}
}

export class SetSidebarPresentAsOverlayVisible implements Action {
	public readonly type = ELayoutActions.SetSidebarPresentAsOverlayVisible;

	constructor(public presentAsOverlayVisible: boolean) {
	}
}

export type LayoutActions =
	SetSidebarPresentAsOverlay |
	SetSidebarPresentAsOverlayVisible
	;
